import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button } from '@mui/material';

// 1. Добавляем isOwnProfile в аргументы
export default function DndSheet({ userId, isOwnProfile }) {
  const [sheet, setSheet] = useState({
    name: '',
    race: '',
    charClass: '',
    level: '',
    hp: '',
    ac: '',
    stats: '',
    skills: '',
    equipment: '',
    appearance: '',
    details: '',
    background: '',    // Предыстория
    raceTraits: '',    // Особенности вида
    classFeatures: '', // Классовые умения
    weapons: ''        // Оружие / боевые заклинания
  });

  useEffect(() => {
    fetch(`/api/profile/dnd/${userId}`)
      .then(res => res.json())
      .then(data => {
        if (data.userId) setSheet(data);
      });
  }, [userId]);

  const handleChange = (e) => {
    setSheet({ ...sheet, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      await fetch('/api/profile/dnd', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, ...sheet })
      });
      alert('Лист персонажа сохранен');
    } catch (error) {
      alert('Ошибка');
    }
  };

  const commonTextFieldProps = {
    fullWidth: true,
    InputLabelProps: { shrink: true },
    sx: { '& .MuiFormLabel-root': { fontStyle: 'italic' } },
    // 2. Блокируем поля, если это не профиль текущего пользователя
    disabled: !isOwnProfile 
  };

  return (
    <Box sx={{ mt: 4, p: 2, borderTop: '1px solid #333' }}>
      <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold', textAlign: 'center' }}>
        D&D лист персонажа
      </Typography>

      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 2 }}>
        <TextField name="name" label="Имя персонажа" value={sheet.name} onChange={handleChange} {...commonTextFieldProps} />
        <TextField name="race" label="Раса" value={sheet.race} onChange={handleChange} {...commonTextFieldProps} />
        <TextField name="charClass" label="Класс" value={sheet.charClass} onChange={handleChange} {...commonTextFieldProps} />
        <TextField name="level" label="Уровень" value={sheet.level} onChange={handleChange} {...commonTextFieldProps} />
        <TextField name="hp" label="Здоровье" value={sheet.hp} onChange={handleChange} {...commonTextFieldProps} />
        <TextField name="ac" label="Класс брони" value={sheet.ac} onChange={handleChange} {...commonTextFieldProps} />
      </Box>

      {/* Многострочные поля */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField 
          name="appearance" 
          label="Внешность" 
          value={sheet.appearance} 
          onChange={handleChange} 
          multiline 
          rows={3} 
          {...commonTextFieldProps} 
        />
        <TextField 
          name="details" 
          label="Детали и особенности" 
          value={sheet.details} 
          onChange={handleChange} 
          multiline 
          rows={3} 
          {...commonTextFieldProps} 
        />
        <TextField 
          name="stats" 
          label="Характеристики (СИЛ, ЛОВ, ТЕЛ, ИНТ, МУД, ХАР)" 
          value={sheet.stats} 
          onChange={handleChange} 
          multiline 
          rows={3} 
          {...commonTextFieldProps} 
        />
        <TextField 
          name="skills" 
          label="Навыки" 
          value={sheet.skills} 
          onChange={handleChange} 
          multiline 
          rows={3} 
          {...commonTextFieldProps} 
        />
        <TextField 
          name="equipment" 
          label="Экипировка" 
          value={sheet.equipment} 
          onChange={handleChange} 
          multiline 
          rows={3} 
          {...commonTextFieldProps} 
        />
        <TextField
        name="background"
        label="Предыстория"
        value={sheet.background || ''}
        onChange={handleChange}
        multiline
        rows={3}
        {...commonTextFieldProps}
        />
        <TextField
        name="raceTraits"
        label="Особенности вида"
        value={sheet.raceTraits || ''}
        onChange={handleChange}
        multiline
        rows={3}
        {...commonTextFieldProps}
        />
        <TextField
        name="classFeatures"
        label="Классовые умения"
        value={sheet.classFeatures || ''}
        onChange={handleChange}
        multiline
        rows={3}
        {...commonTextFieldProps}
        />
        <TextField
        name="weapons"
        label="Оружие / боевые заклинания"
        value={sheet.weapons || ''}
        onChange={handleChange}
        multiline
        rows={3}
        {...commonTextFieldProps}
        />
      </Box>


      {/* 3. Рендерим кнопку только если isOwnProfile === true */}
      {isOwnProfile && (
        <Button 
          variant="contained" 
          fullWidth 
          onClick={handleSave} 
          sx={{ mt: 3, borderRadius: '20px' }}
        >
          Сохранить лист
        </Button>
      )}
    </Box>
  );
}
